module.exports = __webpack_public_path__ + "assets/img/11b.845d8f8c.jpg";